import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20luxurious%20hotel%20entrance%20at%20night%20with%20paparazzi-style%20photography%2C%20dramatic%20lighting%2C%20blurred%20figure%20walking%20in%2C%20cinematic%20composition%2C%20warm%20amber%20street%20lights%2C%20mysterious%20atmosphere%2C%20editorial%20magazine%20quality%2C%20high%20contrast%20shadows&width=800&height=500&seq=article-img-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20modern%20live%20streaming%20studio%20setup%20with%20professional%20lighting%20equipment%2C%20smartphone%20on%20tripod%2C%20beauty%20products%20scattered%20on%20table%2C%20slightly%20chaotic%20atmosphere%2C%20warm%20indoor%20lighting%2C%20documentary%20style%20photography%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=article-img-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20displaying%20social%20media%20profiles%20with%20unfollow%20buttons%20visible%2C%20soft%20moody%20lighting%2C%20melancholy%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20desaturated%20tones%2C%20intimate%20composition&width=800&height=500&seq=article-img-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20TV%20studio%20with%20production%20equipment%2C%20lighting%20rigs%2C%20empty%20stage%20seats%2C%20dramatic%20spotlight%2C%20moody%20atmosphere%2C%20cinematic%20documentary%20style%2C%20contrasty%20lighting%2C%20warm%20and%20cool%20tones%20mix&width=800&height=500&seq=article-img-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=An%20upscale%20private%20dining%20room%20in%20a%20high-end%20Chinese%20restaurant%2C%20round%20table%20with%20dishes%2C%20dim%20warm%20lighting%2C%20recording%20device%20subtly%20placed%2C%20suspenseful%20atmosphere%2C%20cinematic%20photography%2C%20rich%20amber%20tones&width=800&height=500&seq=article-img-05&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20before%20and%20after%20concept%2C%20soft%20beauty%20clinic%20aesthetic%2C%20diffused%20lighting%2C%20elegant%20but%20dramatic%20comparison%2C%20editorial%20magazine%20style%2C%20warm%20peachy%20tones%2C%20professional%20photography&width=800&height=500&seq=article-img-06&orientation=landscape',
};

export default function LatestNewsSection() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="mb-12">
          <span className="text-xs font-medium text-secondary-600 uppercase tracking-widest">
            实时更新
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-heading text-foreground-950">
            今日最新爆料
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={articleImages[article.id] || ''}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-heading text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/60">
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views > 10000
                        ? `${(article.views / 10000).toFixed(1)}万`
                        : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {article.comments}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{article.publishedAt}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/shehui-redian"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}